// extracted by mini-css-extract-plugin
module.exports = {"checkboxTooltip":"oNQ84iTq"};